import { ControlContainer, NgForm } from '@angular/forms';
import { Directive } from '@angular/core';

@Directive({
    selector: '[thr-parent-form]',
    exportAs: 'parent-form',
    providers: [
        {
            provide: ControlContainer,
            useFactory(form: NgForm) {
                return form;
            },
            deps: [NgForm],
        },
    ],
})
export class ParentFormDirective {
    constructor(public controlContainer: ControlContainer) {}
}
